import { useContext } from "react";
import { useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import { userHasPermission } from "@/modules/common/utils";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import TypeCorrection from "@/modules/lead-page/components/lead-info/lead-type/type-correction";
import ReassignReferral from "@/modules/lead-page/components/lead-info/lead-type/reassign-referral";
import ReassignNoreferral from "@/modules/lead-page/components/lead-info/lead-type/reassign-noreferral";
import { LeadTypeOption } from "@/modules/lead-page/constants";
import { DropdownTriggerButton } from "@/modules/common/components/ui-kit/DropdownTriggerButton";
import { ActionsDropdown } from "./actions-drop-down";

export const ChangeLeadAction = () => {
  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);
  const theme = useTheme();

  const hasPermission = userHasPermission(
    {
      name: PermissionsEnum.ADD_ALL_LEAD_TYPES,
      level: PermissionLevel.ALL,
    },
    currentUserPermissions
  );

  const leadTypeItems = [
    {
      jsx: (
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.ADD_ALL_LEAD_TYPES,
              level: PermissionLevel.ALL,
            },
          ]}
        >
          <TypeCorrection />
        </PermissionGuard>
      ),
      name: "Type Correction",
    },
    {
      jsx: (
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.ADD_ALL_LEAD_TYPES,
              level: PermissionLevel.ALL,
            },
          ]}
        >
          <ReassignNoreferral />
        </PermissionGuard>
      ),
      id: LeadTypeOption.ReassignNoReferral,
    },
    {
      jsx: !hasPermission ? <ReassignReferral /> : null,
      name: "Reassign Referral",
    },
  ];

  return (
    <ActionsDropdown
      triggerButton={(handleClick) => (
        <DropdownTriggerButton
          label="Change Lead"
          onClick={handleClick}
          chevron={<ChevronRight size={16} />}
          sx={{
            gap: theme.nawy.spacing.xs,
            padding: theme.nawy.spacing.xs,
            ":hover": {
              backgroundColor: theme.nawy.colors.semantic.layer.secondary,
            },
          }}
        />
      )}
      items={leadTypeItems}
      shouldRenderItem={(item) => item.jsx !== null}
    />
  );
};
